import React from 'react';
import { Card } from "react-bootstrap";
import face_bence_biro from "../../assets/img/face_bence_biro.jpg";
import faceCsabaKiss from "../../assets/img/faceCsabaKiss.png";

import ShowMoreText from "react-show-more-text";
import proj_electricity_resolution from "../../assets/img/proj_electricity_resolution.png";

const Bence_Biro_electricity = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_electricity_resolution} />
        <br />
        <Card.Body>
          <Card.Text className="d-flex justify-content-start card-text">
            {" "}

            <div className="me-5">
            <img
              className="img2"
              src={face_bence_biro}

            />{" "}
            <p className="text7">Bence Bíró</p>
            <br />
            <p className="text8">
              PhD Student{" "}
            </p>
            </div>
            <div>
              <img
                className="img2"
                src={faceCsabaKiss}
                
              />{" "}
              <p className="text7">Csaba Kiss</p>
              <br />
              <p className="text8">
                Phd Student{" "}
              </p>
            </div>   
                        
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Faculty of Natural Sciences, Institute of Nuclear Techniques (NTI) </p>
            </div>
            <div>
            <p className="text8">HSDSLab, BME </p>
            </div>

            <div>
            In the exercise, students will be asked to analyse hourly-resolution reserve market 
            data for the European electricity system based on the European Association for the 
            Cooperation of Transmission System Operators (ENTSO-E) database. After analysing the 
            data, students should review what artificial intelligence models have been built so 
            far in the international literature to forecast reserve demand and reserve market prices. 
            Finally, students should build artificial intelligence models to forecast reserve demand 
            and reserve market prices for selected European countries.
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                    <a href="https://transparency.entsoe.eu/">https://transparency.entsoe.eu/</a>
                </li>
                <li>
                    <a href="https://energy.ec.europa.eu/system/files/2018-05/review_of_the_entso_e_plattform_0.pdf">
                    https://energy.ec.europa.eu/system/files/2018-05/review_of_the_entso_e_plattform_0.pdf</a>
                </li>
                <li>
                    <a href="http://dx.doi.org/10.1016/j.apenergy.2023.120801">http://dx.doi.org/10.1016/j.apenergy.2023.120801</a>
                </li>
                <li>
                    <a href="http://dx.doi.org/10.1016/j.ecmx.2021.100136">http://dx.doi.org/10.1016/j.ecmx.2021.100136</a>
                </li>
                <li>
                    <a href="https://doi.org/10.1016/j.heliyon.2024.e29841">https://doi.org/10.1016/j.heliyon.2024.e29841</a>
                </li>
                <li>
                    <a href="https://doi.org/10.1002/for.2693">https://doi.org/10.1002/for.2693</a>
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Bence_Biro_electricity;